module.exports = __webpack_public_path__ + "media/images/img_top_mv_sp-d1248c376bd56c90eb130bbfa18effb2.jpg";